// extracted by mini-css-extract-plugin
module.exports = {"free-apply":"free_apply_free-apply__dmxu2","title":"free_apply_title__0ECMa","desc":"free_apply_desc__jwlrG"};